<div
    *ngIf="interactionInternal"
    class="agpr-targetingResults-cardWrapper agpr-interactionCard-wrapper agpr-contextMenu-parent"
    [attr.aria-label]="'Discover.interactionView.card' | localize: {type: interactionInternal.typeString | localize, date: interactionInternal.dateString}"
>
    <div class="agpr-targetingResults-card agpr-interactionCard">
        <div class="agpr-interactionCard-firstRow">
            <div class="agpr-interactionCard-firstRow-left">
                <span
                    class="agpr-interactionCard-icon"
                    [ngClass]="interactionInternal.icon"
                ></span>
                <span
                    class="agpr-interactionCard-type"
                >
                    {{ interactionInternal.typeString | localize }}
                </span>
            </div>

            <span
                class="agpr-interactionCard-createdUser"
            >
                {{ interactionInternal.createdUsername }}
            </span>
        </div>

        <i class="agpr-interactionCard-date">
            {{ interactionInternal.date | changeTimeZone: preferences.timeZone: preferences.getDateFormatString(true, true, true) }}
        </i>
        <!-- Summary Section -->
        <div class="agpr-interactionCard-summary">
            <div class="agpr-interactionCard-heading">
                {{ 'Discover.interactionCard.summary' | localize }}
            </div>
            <a
                *ngIf="interactionInternal.type === interactionType.DISTRIBUTION && interactionInternal?.distId; else summary"
                [href]="appBaseHref + 'Discover/distributions/distribution/' + interactionInternal.distId"
                target="_blank"
                class="agpr-interactionCard-summaryLink"
            >
                {{ interactionInternal.summary }}
            </a>
            <ng-template #summary>
                <span>
                    {{ interactionInternal.summary }}
                </span>
            </ng-template>
        </div>
        <!-- Notes / Response Section -->
        @if (interactionInternal.type !== interactionType.DISTRIBUTION && !!interactionInternal.notes) {
            <div class="agpr-interactionCard-notes">
                <div class="agpr-interactionCard-heading">
                    {{ 'Discover.interactionCard.notes' | localize }}
                </div>
                {{ interactionInternal.notes }}
            </div>
        }
        <div class="agpr-interactionCard-lastRow">
            <div class="agpr-interactionCard-distributionRow">
                @if (interactionInternal?.topStat === distributionReportStat.REPLY && interactionInternal.sendFrom) {
                    <agpr-button
                        class="agpr-interactionCard-distributionRow--viewConversation"
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-messages"
                        (click)="viewConversation.emit()"
                        tooltip="Discover.entityProfile.viewConversation"
                    ></agpr-button>
                }
                <span
                    *ngIf="interactionInternal?.topStat"
                    class="agpr-interactionCard-distributionRow-statusChip agpr-infoChip"
                >
                    {{ topStatLabels.get(interactionInternal.topStat) | localize }}
                </span>
                <agpr-button
                    *ngIf="interactionInternal?.events?.length > 0"
                    class="agpr-interactionCard-distributionRow--expandButton"
                    [style]="buttonTypes.icon"
                    [icon]="expanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                    [expanded]="expanded"
                    (click)="expanded = !expanded"
                ></agpr-button>
            </div>
        </div>
    </div>

    <div *ngIf="expanded">
        <div class="agpr-interactionCard-expanded-divider"></div>

        <ng-container *ngFor="let eventParent of eventHierarchy">
            <span class="agpr-interactionCard-expanded-heading">
                {{ eventParent.heading | localize }}
            </span>
            <div class="agpr-interactionCard-expanded-content">
                <ng-container *ngFor="let emailEvent of eventParent.eventList">
                    <div
                        *ngIf="emailEvent.clickedUrl"
                        class="agpr-interactionCard-expanded-contentRow"
                    >
                        <a
                            class="agpr-interactionCard-expanded-contentLink"
                            [href]="emailEvent.clickedUrl"
                            target="_blank"
                        >
                            {{ emailEvent.clickedUrl }}
                        </a>
                        <span>
                            {{ emailEvent.date | changeTimeZone: preferences.timeZone: preferences.getDateFormatString(true, true, true) }}
                        </span>
                    </div>

                    <span
                        *ngIf="!emailEvent.clickedUrl"
                        class="agpr-interactionCard-expanded-contentLabel"
                    >
                        {{ emailEvent.date | changeTimeZone: preferences.timeZone: preferences.getDateFormatString(true, true, true) }}
                    </span>
                </ng-container>
            </div>
        </ng-container>
    </div>

    <div class="agpr-contextMenu bottom right">
        <agpr-button
            *ngIf="interactionInternal.type !== interactionType.DISTRIBUTION"
            icon="fa-regular fa-duotone fa-pen"
            class="agpr-targetingResults-cardWrapper-contextMenu-button"
            tooltip="Discover.interactionView.edit"
            tooltipPosition="top"
            (click)="edit.emit(interactionInternal)"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
        <agpr-button
            *ngIf="interactionInternal.type !== interactionType.DISTRIBUTION"
            icon="fa-regular fa-duotone fa-trash-can"
            class="agpr-targetingResults-cardWrapper-contextMenu-button"
            tooltip="Discover.interactionView.delete"
            tooltipPosition="top"
            (click)="delete.emit(interactionInternal)"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
    </div>
</div>
